import Reactfrom, { useState, useEffect } from 'react'
import "./ShoppingList.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";
import { AiOutlineClose } from 'react-icons/ai';
import axios from 'axios';
import { SingleShop } from './SingleShop';
import { ipAddress } from '../../ipAddress';

interface Props {

}
interface Shops {
  id: number,
  name: string,
  date: string,
  isDone: number,
}

const ShoppingList: React.FC<Props> = () => {

  const [addShop, setAddShop] = useState<boolean>(false);
  const [shop, setShop] = useState<string>('')
  const [shops, setShops] = useState<Shops[]>([])


  const ShoppingList = () => {
    axios.post(ipAddress + "/getShopsList")
      .then((response) => {
        setShops(response.data)

      })
      .catch(function (error) {
        console.log("error!")
      })

  }

  useEffect(() => {
    ShoppingList();

  }, [shops])



  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();

    if (shop) {
      axios.post(ipAddress + "/addShop", {
        id: Math.random(),
        nameShop: shop,
        isDone: 0,

      })
        .then((response) => {

        })
        .catch(function (error) {
          console.log("error!")
        })
    }

    setAddShop(false);
    setShop('');
  }




  return (
    <div className='shoppingList'>
      <div className='title'>
        <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>Lista zakupów</span>
      </div>
      <div className='shoppingList2'>
        <Link to='/ShoppingList'>Do kupienia</Link>
        <Link to='/ShoppingList/Kupione'>Kupione</Link>
      </div>

      <Outlet />

      {addShop ? (
        <form className='addShop' onSubmit={(e) => { handleAdd(e) }}>
          <span className='icon' id='close' onClick={() => setAddShop(false)} ><AiOutlineClose /></span>
          <p>Dodaj sklep</p>
          <div>
            <label htmlFor='nameShop' id='nameShop'>Nazwa sklepu :</label>
          </div>
          <select name='listShops' id='listShops' onChange={(e) => setShop(e.target.value)}>
            <option value="">Wybierz</option>
            <option value="Aldi">Aldi</option>
            <option value='Biedronka'>Biedronka</option>
            <option value="Delikatesy Centrum">Delikatesy</option>
            <option value="E.Leclerc">E.Leclerc</option>
            <option value="Kaufland">Kaufland</option>
            <option value='Lidl'>Lidl</option>
            <option value="Netto">Netto</option>
            <option value="Stokrotka">Stokrotka</option>

          </select>

          <label htmlFor='nameShop' id='writeName'> lub </label>
          <div>
            <input type="text" placeholder=' Wpisz własną nazwe' onChange={(e) => setShop(e.target.value)} />
          </div>

          <button type='submit'>OK</button>
        </form>
      ) :
        (
          <div></div>
        )}

      <div>
        {shops.map((shop) => (
          <SingleShop shop={shop} key={shop.id} />
        ))

        }
      </div>


      <footer>
        <button type='button' onClick={() => setAddShop(true)} id='circle'><p>+</p></button>
      </footer>
    </div>
  )
}

export default ShoppingList;